import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import SEO from "@/components/seo/SEO";
import { useSearchParams } from "react-router-dom";

export default function AccessNotProvisioned() {
  const [params] = useSearchParams();
  const reason = params.get("reason");

  const onSignOut = async () => {
    await supabase.auth.signOut();
    window.location.href = "/login";
  };

  let title = "Access Not Provisioned";
  let body =
    "You've signed in successfully with Microsoft, but your account hasn't been provisioned in CSV Pro yet. Please contact your CSV Pro administrator to request access.";

  if (reason === "admin_sso_not_allowed") {
    title = "SSO Not Allowed for Admins";
    body =
      "Microsoft SSO is not permitted for Admin accounts. Please sign in using your CSV Pro email and password.";
  } else if (reason === "pm_tier1_sso_not_allowed") {
    title = "SSO Not Allowed for This Account";
    body =
      "Microsoft SSO is not enabled for Tier 1 Portfolio Managers. Please sign in using your CSV Pro email and password.";
  }

  return (
    <>
      <SEO title={`${title} | CSV Pro`} description="Your account isn't allowed to use SSO." />
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="max-w-md w-full bg-card border border-border rounded-xl p-8 text-center">
          <div className="text-amber-500 text-5xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold mb-2">{title}</h1>
          <p className="text-muted-foreground mb-6">{body}</p>
          <Button onClick={onSignOut} className="w-full">
            Back to login
          </Button>
        </div>
      </div>
    </>
  );
}
